import React, { useState } from 'react'
import { Button, Drawer, Space } from 'antd'
import { v4 as uuidv4 } from 'uuid'
import './styles.scss'

interface IPROPS {
  open: any
  setOpen: any
  chartDATA: any
  rowValues: any
  // selectedChartId: any
  nullValues: any
  valueUnique: any
  getTableRow: any
  identifier: any
}

const DrawerComp: React.FC<IPROPS> = ({
  open,
  setOpen,
  chartDATA,
  nullValues,
  valueUnique,
  getTableRow,
  identifier
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)

  const onClose = () => {
    setOpen(false)
  }

  // Define progress bar styles directly
  const progressStyle = {
    width: '100%',
    backgroundColor: '#e9ecef',
    borderRadius: '0.25rem',
    height: '10px',
    marginBottom: '5px',
    position: 'relative' as const
  }

  const progressBarStyle = (percentage: number) => ({
    width: `${percentage}%`,
    height: '100%',
    backgroundColor: '#0085ff',
    borderRadius: '0.25rem',
    transition: 'width 0.3s ease'
  })

  return (
    <>
      <Drawer
        title={identifier}
        width={500}
        onClose={onClose}
        open={open}
        extra={
          <Space>
            <Button onClick={onClose}>X</Button>
          </Space>
        }
      >
        <div style={{ display: 'flex', width: '100%' }}>
          <p
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              border: '1px solid hsl(240, 17.4%, 91%)',
              margin: '0px',
              width: '33%',
              padding: '16px'
            }}
          >
            <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Rows</span>
            <span style={{ fontSize: '20px', color: 'hsl(240, 46.3%, 8%)' }}>{getTableRow}</span>
          </p>
          <p
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '0px',
              width: '33%',
              border: '1px solid hsl(240, 17.4%, 91%)',
              padding: '16px'
            }}
          >
            <>
              <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Empty Rows</span>
              <span style={{ fontSize: '20px', color: 'hsl(240, 46.3%, 8%)' }}>{nullValues}</span>
            </>
          </p>
          <p
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '0px',
              width: '33%',
              border: '1px solid hsl(240, 17.4%, 91%)',
              padding: '16px'
            }}
          >
            <span style={{ color: 'hsl(240, 10.3%, 38%)', fontSize: '12px' }}>Unique Values</span>
            <span style={{ fontSize: '20px', color: 'hsl(240, 46.3%, 8%)' }}>{valueUnique}</span>
          </p>
        </div>
        <div style={{ padding: '20px', overflow: 'scroll' }}>
          {/* Dropdown */}
          {chartDATA?.top_10_values?.length > 0 && (
            <div>
              <div>
                {chartDATA?.top_10_values
                  ?.slice(0, dropdownOpen ? chartDATA?.top_10_values.length : 5)
                  .map((data: any, index: number) => {
                    // Ensure percentage is a number
                    const percentage = parseFloat(data?.percentage) || 0

                    return (
                      <div
                        key={uuidv4()}
                        style={{ display: 'flex', flexDirection: 'column', marginBottom: '15px' }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%',
                            marginBottom: '5px'
                          }}
                        >
                          <span style={{ width: '70%' }}>{data?.value ? data?.value : 'NaN'}</span>
                        </div>

                        {/* Custom styled progress bar */}
                        <div style={progressStyle}>
                          <div style={progressBarStyle(percentage)}></div>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span>Percentage: {percentage.toFixed(2)}%</span>
                          <span>Count: {data?.count}</span>
                        </div>
                        <hr />
                      </div>
                    )
                  })}
              </div>
            </div>
          )}

          {chartDATA?.top_10_values?.length > 5 && (
            <div style={{ width: '100%', textAlign: 'center', marginBottom: '250px' }}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                style={{
                  border: 'none',
                  color: 'rgb(0, 133, 255)',
                  background: 'rgb(229, 243, 255)',
                  borderRadius: '10px',
                  padding: '10px'
                }}
              >
                {dropdownOpen ? (
                  <p
                    style={{
                      margin: '0',
                      display: 'flex',
                      gap: '15px',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <span>
                      <i className='bi bi-chevron-up'></i>
                    </span>
                    <span>Show less</span>
                  </p>
                ) : (
                  <p
                    style={{
                      margin: '0',
                      display: 'flex',
                      gap: '15px',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <span>
                      <i className='bi bi-chevron-down'></i>
                    </span>
                    <span>Show More</span>
                  </p>
                )}
              </button>
            </div>
          )}
        </div>
      </Drawer>
    </>
  )
}

export default DrawerComp
